import { Component, OnInit } from "@angular/core";
import {
  FormControl,
  Validators,
  FormBuilder,
  FormGroup,
} from "@angular/forms";
import { AuthService } from "../auth.service";
import { ActivatedRoute, Router } from "@angular/router";
import { MyErrorStateMatcher } from "../../_helpers/errorStateMather";
import { DataService } from "src/app/_services/data.service";
import { environment } from "../../../environments/environment";
import { ReCaptchaV3Service } from "ngx-captcha";
import {catchError, tap} from 'rxjs/operators';
import {throwError} from 'rxjs';

@Component({
  selector: "app-login",
  templateUrl: "./login.component.html",
  styleUrls: ["./login.component.scss"],
})
export class LoginComponent implements OnInit {
  returnUrl;
  method;
  sendPassword = false;
  error: string;
  matcher = new MyErrorStateMatcher();
  showSMSCode = false;
  codeTimeout = false;
  disabledSubmit = false;

  showPassword = false;

  open = null;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private authService: AuthService,
    private dataService: DataService,
    private readonly reCaptchaV3Service: ReCaptchaV3Service,
    private fb: FormBuilder
  ) {}

  loginForm = new FormGroup({
    login: new FormControl("", [Validators.required, Validators.email]),
    password: new FormControl("", Validators.required),
    code: new FormControl(""),
  });

  ngOnInit() {
    this.returnUrl = this.route.snapshot.queryParams["returnUrl"] || "/";
    this.sendPassword = this.route.snapshot.queryParams["sendPassword"];
    // this.sendPassword = true;
  }

  startCodeTime() {
    setTimeout(() => {
      this.showSMSCode = null;
      this.loginForm.get("password").enable();
      this.loginForm.get("code").clearValidators();
      this.loginForm.get("code").updateValueAndValidity();
      this.codeTimeout = true;
    }, 120000);
  }

  onSubmit() {
    this.sendPassword = false;
    this.error = null;

    if (this.loginForm.valid) {
      if (this.showSMSCode) {
        const sendValue = {
          username: this.loginForm.value.login,
          code: this.loginForm.value.code,
        };

        this.reCaptchaV3Service.execute(
          environment.capchaKey,
          "homepage",
          (token) => {
            this.dataService
              .invoke(
                `login/obtain-token`,
                "post",
                { recaptchaKey: token },
                sendValue,
                null
              )
              .subscribe(
                (res) => {
                  this.okResponse(res);
                },
                (err) => {
                  this.errResponse(err);
                }
              );
          },
          {
            useGlobalDomain: false,
          }
        );
      } else {
        const sendValue = {
          username: this.loginForm.value.login,
          password: this.loginForm.value.password,
        };
        this.codeTimeout = false;
        this.disabledSubmit = true;
        this.reCaptchaV3Service.execute(
          environment.capchaKey,
          "homepage",
          (token) => {
            this.dataService
              .invoke(
                `login/check-user`,
                "post",
                { recaptchaKey: token },
                sendValue,
                null
              )
              .subscribe(
                (res) => {
                  this.disabledSubmit = false;
                  if (res.token) {
                    this.okResponse(res);
                  } else {
                    this.showSMSCode = true;
                    this.startCodeTime();
                    this.loginForm.get("password").disable();
                    this.loginForm
                      .get("code")
                      .setValidators([Validators.required]);
                    // this.loginForm.get('code').updateValueAndValidity();
                    this.loginForm.get("code").markAsUntouched();
                  }
                },
                (err) => {
                  this.disabledSubmit = false;
                  this.errResponse(err);
                }
              );
          },
          {
            useGlobalDomain: false,
          }
        );
      }
    }
  }


  lorealLogin() {
    this.authService.lorealLogin()
      .pipe(
        catchError((error) => {
          return throwError(() => error);
        }),
        tap((resp: any) => {
          const url = new URL(resp.location);
          const state = url.searchParams.get('state');
          localStorage.setItem('state', state);
          location.assign(resp.location);
        })
      )
      .subscribe();
  }

  okResponse(res) {
    sessionStorage.setItem("userToken", JSON.stringify(res));
    setTimeout(() => {
      this.router.navigate([this.returnUrl]);
    }, 100);
  }

  errResponse(err) {
    if (
      err.message === "Invalid username or password." ||
      err.message === "Bad credentials" ||
      err.message === "Invalid credentials."
    ) {
      this.error = "Niepoprawna nazwa użytkownika lub hasło.";
    }
    if (
      err.message === "Invalid or expired SMS Code." ||
      err.message === "Invalid username or SMS Code"
    ) {
      this.error = "Niepoprawny kod SMS.";
    }
  }
}
